import { set } from 'cerebral/operators'
import { props, state } from 'cerebral/tags'
import hasFocusedOption from '../actions/hasFocusedOption'
import hasFilteredOptions from '../actions/hasFilteredOptions'

export default [
  hasFilteredOptions,
  {
    true: [
      hasFocusedOption,
      {
        true: [],
        false: [set(state`selectr.${props`namespace`}.focusedOption`, 0)]
      }
    ],
    false: []
  }
]
